export default __webpack_public_path__ + "static/barn-demolition-icon-e8a16288116cd47b646ef64eee3a0a21.png";